export const Product = {
  getProductReview: {
    url: "/product/review/{productId}",
    method: ["GET"]
  },
  createProductReview: {
    url: "/product/review",
    method: ["POST"],
    required: [
      "rating",
      "nickname",
      "title",
      "review",
      "productId"
    ]
  }

};
